import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation CreateTenant($input: TenantInput!) {
    createTenant(input: $input) {
      id
      alias
      code
      name
      color
      createdBy
      monthlyCreditLimit
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.CreateTenantMutation,
    ents.core.admin.Tenant,
    'createTenant'
  >(
    'createTenant',
    graphql.transformers.OUT.object({
      alias: graphql.transformers.OUT.validate(
        transformers.PASS_THROUGH,
        TypeAsserter.assertIsNotNullish,
        { warnOnly: true },
      ),
      code: graphql.transformers.OUT.validate(
        transformers.PASS_THROUGH,
        TypeAsserter.assertIsNotNullish,
        { warnOnly: true },
      ),
      color: transformers.PASS_THROUGH,
      createdBy: transformers.PASS_THROUGH,
      monthlyCreditLimit: transformers.PASS_THROUGH,
      id: graphql.transformers.OUT.validate(
        transformers.PASS_THROUGH,
        TypeAsserter.assertIsNotNullish,
        { warnOnly: true },
      ),
      name: graphql.transformers.OUT.validate(
        transformers.PASS_THROUGH,
        TypeAsserter.assertIsNotNullish,
        { warnOnly: true },
      ),
    }),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.CreateTenantMutation,
  ents.core.admin.Tenant,
  graphql.schema.CreateTenantMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
